function lrToggleAccordion(toggle) {
  var accordion = toggle.closest('.lr-accordion');
  var panel = accordion.querySelector('.lr-accordion-panel');
  if (accordion.classList.contains('is-open')) {
    accordion.classList.remove('is-open');
    panel.style.maxHeight = '0';
  } else {
    accordion.classList.add('is-open');
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }
}

function lrToggleDetail(rank) {
  var panel = document.getElementById('lr-detail-' + rank);
  var card = document.querySelector('.lr-card[data-rank="' + rank + '"]');
  var allPanels = document.querySelectorAll('.lr-detail-panel');
  var allCards = document.querySelectorAll('.lr-card');
  var isOpen = panel.classList.contains('is-open');

  allPanels.forEach(function(p) {
    p.classList.remove('is-open');
    p.style.maxHeight = '0';
  });
  allCards.forEach(function(c) {
    c.classList.remove('is-active');
    var btn = c.querySelector('.lr-card-detail-btn');
    if (btn) btn.textContent = '詳しく見る';
  });

  if (!isOpen) {
    panel.classList.add('is-open');
    panel.style.maxHeight = panel.scrollHeight + 'px';
    if (card) {
      card.classList.add('is-active');
      var btn = card.querySelector('.lr-card-detail-btn');
      if (btn) btn.textContent = '閉じる';
    }
  } else {
    setTimeout(function() {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }
}
